import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Home from 'page/Home';
import Features from 'page/Features';
import Collection from 'page/Collection';
import Search from 'page/Search';
import Player from 'page/Player';
import Schedule from 'page/Schedule';
import ShortStopLive from 'page/ShortStopLive';
import Activate from 'page/Activate';
import Test from 'page/Test';
import ConnectedRootApplicationShell from './RootApplicationShell';
import BasicShell from './subShell/BasicShell';
import PageShell from './subShell/PageShell';

function createRoutes() {
    return ([
        <Route path="/" component={ConnectedRootApplicationShell}>
            <Route component={BasicShell} key="route_0">
                <Route path="activate" component={Activate} />
                <Route path="test" component={Test} />
            </Route>
            <Route component={PageShell} key="route_1">
                <IndexRoute component={Home} />
                <Route path="_/*" component={Home} />
                <Route path="collections/:id(/g/:groupId)(/:junk)" component={Collection} />
                <Route path="schedule" component={Schedule} />
                <Route path="player" component={Player} />
                <Route path="shortstoplive" component={ShortStopLive} />
                <Route path="search(/:searchTerm)" component={Search} />
                <Route path=":pageName" component={Features} />
            </Route>
        </Route>
    ]);
}

export default createRoutes;



// WEBPACK FOOTER //
// ./app/routes.js